export const TRACKER_ACTIVE = 'tracker_active';
export const TRACKER_BROKEN = 'tracker_broken';
export const TRACKER_MISSING = 'tracker_missing';

export const TrackerStatesEnum: string[] = [ TRACKER_ACTIVE, TRACKER_BROKEN, TRACKER_MISSING ];



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/TrackerStates.ts